import { BaseEvent, eventRegistry } from "@Context/common/general/event-context";
import * as t from "io-ts";

const UserAvatarUpdatedCodec = t.type({
  type: t.literal("user:avatar:updated"),
  timestamp: t.number,
  avatar: t.union([t.string, t.null]),
});

export interface UserAvatarUpdatedEvent extends BaseEvent {
  type: "user:avatar:updated";
  avatar: string | null;
}

export const userAvatarUpdatedEmitter = eventRegistry.registerEventType<typeof UserAvatarUpdatedCodec, UserAvatarUpdatedEvent>(
  "user:avatar:updated",
  UserAvatarUpdatedCodec
);
